import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { withTranslation } from 'react-i18next';
import { KeyboardDatePicker, DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import MomentUtils from '@date-io/moment';
import Modal from '@material-ui/core/Modal';
import DataReactTable from '../../MedicalOrders/DataReactTable';
import ReactTableActionsMedics from '../../MedicalOrders/ReacTableActionsMedics';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import Button from '@material-ui/core/Button';
import ReactTableActionsDiagnostic from '../../Diagnostic/ReactTableActionsDiagnostic';
import moment from 'moment';
import { isUndefined } from 'lodash';

const renderField = ({
    input, placeholder, type, meta: { touched, error },
}) => (
    <div className="form__form-group-input-wrap form__form-group-input-wrap--error-above">
        <input {...input} placeholder={placeholder} type={type} />
        {touched && error && <span className="form__form-group-error">{error}</span>}
    </div>
);

renderField.propTypes = {
    input: PropTypes.shape().isRequired,
    placeholder: PropTypes.string,
    type: PropTypes.string,
    meta: PropTypes.shape({
        touched: PropTypes.bool,
        error: PropTypes.string,
    }),
};

renderField.defaultProps = {
    placeholder: '',
    meta: null,
    type: 'text',
};

class SectionAilment extends Component {
    constructor() {
        super();
        this.state = {
            sectionAilment: {},
            showCommentaties: [],
            commentaries: [],
            openMedicaments: false,
            loadMedicaments: true,
            useMediTable: false,
            medicament: [],
            dataMedicaments: [],
            openModal: false,
            load: true,
            dataDiagnostic: [],
            diagnostic: [],
            tableData: [],
            showTable: false,
            vacuna: "",
            principioactivo: "",
            concentracion: "",
            viaadministracion: "",
            observation:""
        }
    }

    //this.props.handlerObservation

    componentDidUpdate(prevProps, prevState) {
        //console.log("PROPSAILMENT", this.props);
        if (prevProps.sectionAilment !== this.props.sectionAilment) {
            return {
                sectionAilment: this.props.sectionAilment
            }
        }
    }

    componentDidMount() {
        this.setState({ showCommentaties: new Array(this.props.sectionAilment[this.props.section].length), commentaries: new Array(this.props.sectionAilment[this.props.section].length) })
    }

    render() {

        const row = {};

        const reactTableMedicaments = {
            tableHeaderData: [{
                Header: 'Principio activo',
                accessor: 'principioactivo',
                disableGlobalFilter: true,
                width: 65,
            },
            {
                Header: 'Producto',
                accessor: 'producto',
            },
            {
                Header: 'Forma Farmacéutica',
                accessor: 'formafarmaceutica',
            },
            {
                Header: 'Codigo',
                accessor: 'atc',
            },
            ],
            tableRowsData: this.state.dataMedicaments
        };

        return (
            <div className="form" style={{ display: "flex", flexDirection: "column" }}>
                <div style={{ display: "flex", width: '100%', marginTop: 20 }}>
                    <div style={{ width: '50%' }}>
                        {this.props.sectionAilment[this.props.section].map((ailment, index) => {
                            if (index % 2 !== 1) {
                                return (<Fragment key={ailment.ailment}>
                                    <div key={ailment.ailment} style={{ display: 'flex', height: 70 }}>
                                        <div style={{ width: 200 }}>
                                            <span className="form__form-group-label">{ailment.ailment}</span>
                                            <div className="form__form-group-field">
                                                <label className="radio-btn" >
                                                    <input
                                                        className="radio-btn__radio"
                                                        name={this.props.section + '-' + ailment.ailment}
                                                        type="radio"
                                                        value={'Si'}
                                                        checked={ailment.value === 'Si'}
                                                        onChange={(e) => {
                                                            this.props.handlerAilment(e.target.value, this.props.section, this.props.sectionIndex, index);
                                                            var showCommentaties = this.state.showCommentaties;
                                                            showCommentaties[index] = true;
                                                            this.setState({ showCommentaties: showCommentaties })
                                                        }}
                                                    />
                                                    <span className="radio-btn__radio-custom" />
                                                    <span className="radio-btn__label">{"Sí"}</span>
                                                </label>
                                                <label className="radio-btn" >
                                                    <input
                                                        className="radio-btn__radio"
                                                        name={this.props.section + '-' + ailment.ailment}
                                                        type="radio"
                                                        value={'No'}
                                                        checked={ailment.value === 'No'}
                                                        onChange={(e) => {
                                                            this.props.handlerAilment(e.target.value, this.props.section, this.props.sectionIndex, index);
                                                            var showCommentaties = this.state.showCommentaties;
                                                            showCommentaties[index] = false;
                                                            this.setState({ showCommentaties: showCommentaties })
                                                        }}
                                                    />
                                                    <span className="radio-btn__radio-custom" />
                                                    <span className="radio-btn__label">{"No"}</span>
                                                </label>
                                            </div>
                                        </div>

                                        {this.props.sectionIndex === 2 || this.props.sectionIndex === 4 ? null :
                                            <div className="form__form-group" style={{ width: '100%', marginRight: 20 }}>
                                                <div className="form__form-group-field">
                                                    <input
                                                        key={`comment-${ailment.ailment}`}
                                                        name={`comment-${ailment.ailment}`}
                                                        disabled={ailment.value !== "Si"}
                                                        type="text"
                                                        //placeholder="NO REFIERE."
                                                        defaultValue={this.state.commentaries[index] != undefined ? this.state.commentaries[index] : null}
                                                        value={ailment.commentary}
                                                        onChange={(e) => {
                                                            this.props.handlerCommentary(e.target.value, this.props.section, this.props.sectionIndex, index);
                                                            var commentaries = this.state.commentaries;
                                                            commentaries[index] = e.target.value;
                                                            this.setState({ commentaries: commentaries })
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        }
                                    </div>
                                    {this.props.sectionIndex === 2 && ailment.value === "Si" ?
                                        <table className="table table--bordered" >
                                            <thead>
                                                <tr>
                                                    <td>Buscar </td>
                                                    <td >Principio Activo - Denominación Común Internacional </td>
                                                    <td >Concentración </td>
                                                    <td >Vía de Administración </td>
                                                    <td >Dosis </td>
                                                    <td >Frecuencia </td>
                                                    <td >Fecha Inicio </td>
                                                    <td >Fecha Fin </td>
                                                    <td ></td>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td><Button
                                                        color="primary"
                                                        style={{ paddingLeft: 10, margin: 'auto', fontSize: 20 }}
                                                        onClick={() => {

                                                            this.setState({ openMedicaments: true });
                                                        }}
                                                    >
                                                        <span className="lnr lnr-magnifier" style={{ fontSize: 20 }} />
                                                    </Button> </td>
                                                    <td ><TextField
                                                        required
                                                        type="text"
                                                        className="material-form__field"
                                                        style={{ width: 350 }}
                                                        value={this.state.principioactivo}
                                                        onChange={(event) => {
                                                            this.setState({ principioactivo: event.target.value })
                                                        }}
                                                    /> </td>
                                                    <td ><TextField
                                                        required
                                                        type="text"
                                                        className="material-form__field"
                                                        style={{ width: 100 }}
                                                        value={this.state.concentracion}
                                                        onChange={(event) => {
                                                            this.setState({ concentracion: event.target.value })
                                                        }}
                                                    />  </td>
                                                    <td ><TextField
                                                        required
                                                        type="text"
                                                        className="material-form__field"
                                                        style={{ width: 150 }}
                                                        value={this.state.viaadministracion}
                                                        onChange={(event) => {
                                                            this.setState({ viaadministracion: event.target.value })
                                                        }}
                                                    /> </td>
                                                    <td ><TextField
                                                        required
                                                        type="number"
                                                        className="material-form__field"
                                                        style={{ width: 80 }}
                                                        value={this.state.dosis}
                                                        onChange={(event) => {
                                                            this.setState({ dosis: event.target.value })

                                                        }}
                                                    />  </td>
                                                    <td ><TextField
                                                        className="material-form__field"
                                                        style={{ width: 180, marginTop: 12 }}
                                                        select
                                                        onChange={(event) => {

                                                            row.frecuencia = event.target.value;
                                                        }}
                                                    >
                                                        <MenuItem className="material-form__option" key={0} value={'Una vez al día'}>Una vez al día</MenuItem>
                                                        <MenuItem className="material-form__option" key={1} value={'Dos veces al día'}>Dos veces al día</MenuItem>
                                                        <MenuItem className="material-form__option" key={2} value={'Tres veces al día'}>Tres veces al día</MenuItem>
                                                        <MenuItem className="material-form__option" key={3} value={'Cuatro veces al día'}>Cuatro veces al día</MenuItem>
                                                        <MenuItem className="material-form__option" key={4} value={'Dos veces a la semana'}>Dos veces a la semana</MenuItem>
                                                        <MenuItem className="material-form__option" key={5} value={'Cada mes'}>Cada mes</MenuItem>
                                                        <MenuItem className="material-form__option" key={6} value={'Cada dos meses'}>Cada dos meses</MenuItem>
                                                        <MenuItem className="material-form__option" key={7} value={'Cada seis meses'}>Cada seis meses</MenuItem>
                                                        <MenuItem className="material-form__option" key={8} value={'Dosis unica'}>Dosis unica</MenuItem>
                                                    </TextField> </td>
                                                    <td >  <MuiPickersUtilsProvider utils={MomentUtils} >
                                                        <DatePicker
                                                            format="yyyy/MM/DD"
                                                            animateYearScrolling
                                                            style={{ width: 180 }}
                                                            disabled={ailment.value !== "Si"}
                                                            InputLabelProps={{
                                                                shrink: true,
                                                            }}
                                                            onChange={(date) => {
                                                                row.fecha_inico = moment(new Date(date)).format('YYYY-MM-DD');
                                                            }}
                                                        />
                                                    </MuiPickersUtilsProvider></td>
                                                    <td >  <MuiPickersUtilsProvider utils={MomentUtils} >
                                                        <DatePicker
                                                            format="yyyy/MM/DD"
                                                            animateYearScrolling
                                                            style={{ width: 180 }}
                                                            disabled={ailment.value !== "Si"}
                                                            InputLabelProps={{
                                                                shrink: true,
                                                            }}
                                                            onChange={(date) => {
                                                                row.fecha_fin = moment(new Date(date)).format('YYYY-MM-DD');
                                                            }}
                                                        />
                                                    </MuiPickersUtilsProvider></td>
                                                    <td ><Button color="primary" onClick={() => {

                                                        row.principioactivo = this.state.principioactivo;
                                                        row.concentracion = this.state.concentracion;
                                                        row.viaadministracion = this.state.viaadministracion;
                                                        row.dosis = this.state.dosis;

                                                        if (Object.keys(row).length !== 0 || this.state.medicament.length !== 0) {

                                                            this.setState(prevState => ({
                                                                tableData: [...prevState.tableData, row]
                                                            }));

                                                            this.setState({ showTable: true }, () => {
                                                                this.props.handlerAlimentTable(this.state.tableData, this.props.section, this.props.sectionIndex, index);
                                                                this.setState({ dosis: '', principioactivo: '', viaadministracion: "", concentracion: "" })

                                                            });

                                                        } else {
                                                            alert("No ha ingresado los valores");
                                                        }

                                                    }}>
                                                        <span className="lnr lnr-plus-circle" style={{ margin: 'auto', fontSize: 20 }} />
                                                    </Button></td>
                                                </tr>
                                                {this.state.showTable ?
                                                    this.state.tableData.map((data, num) => {
                                                        return <tr key={num}>
                                                            <td></td>
                                                            <td>{data.principioactivo}</td>
                                                            <td>{data.concentracion}</td>
                                                            <td>{data.viaadministracion}</td>
                                                            <td>{data.dosis}</td>
                                                            <td>{data.frecuencia}</td>
                                                            <td>{data.fecha_inico}</td>
                                                            <td>{data.fecha_fin}</td>
                                                            <td><Button color="primary" onClick={() => {
                                                                this.setState({ showTable: false });
                                                                this.state.tableData.splice(num, 1);
                                                                this.setState({ showTable: true }, () => {
                                                                    this.props.handlerAlimentTable(this.state.tableData, this.props.section, this.props.sectionIndex, index);
                                                                });
                                                            }}>
                                                                <span className="lnr lnr-trash" style={{ margin: 'auto', fontSize: 20 }} />
                                                            </Button>
                                                            </td>
                                                        </tr>
                                                    })
                                                    : null}
                                            </tbody>
                                        </table>
                                        : null}
                                    {this.props.sectionIndex === 4 && ailment.value === "Si" ?
                                        <table className="table table--bordered" >
                                            <thead>
                                                <tr>
                                                    <td >Vacuna </td>
                                                    <td >Fecha de Aplicación </td>
                                                    <td ></td>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td><TextField
                                                        type="text"
                                                        className="material-form__field"
                                                        style={{ width: 350 }}
                                                        value={this.state.vacuna}
                                                        onChange={(e) => {
                                                            this.setState({ vacuna: e.target.value });
                                                        }}
                                                    />
                                                    </td>
                                                    <td> <MuiPickersUtilsProvider utils={MomentUtils} >
                                                        <DatePicker
                                                            autoOk
                                                            className="material-form__field"
                                                            format="yyyy/MM/DD"
                                                            animateYearScrolling
                                                            style={{ width: 180 }}
                                                            onChange={(date) => {
                                                                row.fecha = moment(new Date(date)).format('YYYY-MM-DD');
                                                            }}
                                                        />
                                                    </MuiPickersUtilsProvider></td>
                                                    <td><Button color="primary" onClick={() => {
                                                        if (Object.keys(row).length !== 0) {
                                                            row.vacuna = this.state.vacuna;

                                                            this.setState(prevState => ({
                                                                tableData: [...prevState.tableData, row]
                                                            }));
                                                            this.setState({ showTable: true }, () => {
                                                                this.props.handlerAlimentTable(this.state.tableData, this.props.section, this.props.sectionIndex, index);

                                                            });
                                                            this.setState({ vacuna: " " });
                                                        } else {
                                                            alert("No ha ingresado los valores");
                                                        }
                                                    }}>
                                                        <span className="lnr lnr-plus-circle" style={{ margin: 'auto', fontSize: 20 }} />
                                                    </Button></td>
                                                </tr>
                                                {this.state.showTable ?
                                                    this.state.tableData.map((data, num) => {
                                                        return <tr key={num}>
                                                            <td>{data.vacuna}</td>
                                                            <td>{data.fecha}</td>
                                                            <td><Button color="primary" onClick={() => {
                                                                this.setState({ showTable: false });
                                                                this.state.tableData.splice(num, 1);
                                                                this.setState({ showTable: true }, () => {
                                                                    this.props.handlerAlimentTable(this.state.tableData, this.props.section, this.props.sectionIndex, index);
                                                                });
                                                            }}>
                                                                <span className="lnr lnr-trash" style={{ margin: 'auto', fontSize: 20 }} />
                                                            </Button>
                                                            </td>
                                                        </tr>
                                                    })
                                                    : null}
                                            </tbody>
                                        </table>
                                        : null}
                                </Fragment>)
                            }
                        })}
                        {this.props.sectionIndex === 0 ? 
                        <div className="form__form-group-field">
                            <div className="form">
                                <div className="card__title">
                                    <h5 className="bold-text">Observaciones</h5>
                                </div>
                                <div className="form__form-group-field" >
                                    <textarea
                                        name="textarea-nutricional"
                                        style={{ width: '100%' }}
                                        defaultValue={this.props.sectionAilment.observation}
                                        onChange={(e) => {
                                            this.props.handlerObservation(
                                                e.target.value
                                            )
                                        }}
                                    >
                                    </textarea>
                                </div>
                            </div>
                        </div>
                        : null
                        }
                        <div className="form__form-group">
                            {/* <span className="form__form-group-label">Observación</span>
                            <div className="form__form-group-field">
                                <Field
                                    name="Observacion"
                                    component={renderField}
                                    type="text"
                                    value={this.state.observation}
                                    onChange={(e) => { this.handlerObservation(e.target.value) }}
                                />
                            </div> */}
                        </div>
                    </div>
                    <div style={{ width: '50%' }}>
                        {this.props.sectionAilment[this.props.section].map((ailment, index) => {
                            if (index % 2 === 1) {
                                return (<div key={ailment.ailment} style={{ display: 'flex', height: 70 }}>
                                    <div style={{ width: 200 }}>
                                        <span className="form__form-group-label">{ailment.ailment}</span>
                                        <div className="form__form-group-field">
                                            <label
                                                className="radio-btn"
                                            >
                                                <input
                                                    className="radio-btn__radio"
                                                    name={this.props.section + '-' + ailment.ailment}
                                                    type="radio"
                                                    value={'Si'}
                                                    checked={ailment.value === "Si"}
                                                    onChange={(e) => {
                                                        console.log(e);
                                                        this.props.handlerAilment(e.target.value, this.props.section, this.props.sectionIndex, index);
                                                        var showCommentaties = this.state.showCommentaties;
                                                        showCommentaties[index] = true;
                                                        this.setState({ showCommentaties: showCommentaties })
                                                    }}
                                                />
                                                <span className="radio-btn__radio-custom" />
                                                <span className="radio-btn__label">{"Sí"}</span>
                                            </label>
                                            <label
                                                className="radio-btn"
                                            >
                                                <input
                                                    className="radio-btn__radio"
                                                    name={this.props.section + '-' + ailment.ailment}
                                                    type="radio"
                                                    value={'No'}
                                                    checked={ailment.value === "No"}
                                                    onChange={(e) => {
                                                        this.props.handlerAilment(e.target.value, this.props.section, this.props.sectionIndex, index);
                                                        var showCommentaties = this.state.showCommentaties;
                                                        showCommentaties[index] = false;
                                                        this.setState({ showCommentaties: showCommentaties })
                                                    }}
                                                />
                                                <span className="radio-btn__radio-custom" />
                                                <span className="radio-btn__label">{"No"}</span>
                                            </label>
                                        </div>
                                    </div>

                                    <div className="form__form-group" style={{ width: '100%', marginRight: 20 }}>
                                        <div className="form__form-group-field">
                                            <input
                                                key={`comment-${ailment.ailment}`}
                                                name={`comment-${ailment.ailment}`}
                                                disabled={ailment.value !== "Si"}
                                                type="text"
                                                placeholder="NO REFIERE."
                                                value={ailment.commentary}
                                                onChange={(e) => {
                                                    this.props.handlerCommentary(e.target.value, this.props.section, this.props.sectionIndex, index);
                                                    var commentaries = this.state.commentaries;
                                                    commentaries[index] = e.target.value;
                                                    this.setState({ commentaries: commentaries })
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>)
                            }
                        })}
                        <Modal
                            open={this.state.openMedicaments}
                            onClose={() => {
                                this.setState({ openMedicaments: false });
                            }}
                            aria-labelledby="simple-modal-title"
                            aria-describedby="simple-modal-description"
                            style={{ zIndex: 1000 }}
                        >
                            <div className="paperAppointment-flex" style={{ width: '100%', margin: 10 }}>
                                <div>
                                    <h5 className="bold-text">Medicamentos</h5>
                                </div>
                                <div className="form">
                                    <div style={{ display: 'flex', width: '100%' }}>
                                        <div className="form__form-group" style={{ marginRight: 10 }}>
                                            <span className="form__form-group-label">Principio Activo</span>
                                            <div className="form__form-group-field">
                                                <Field
                                                    name="search-cups"
                                                    component="input"
                                                    type="text"
                                                    placeholder="nombre"
                                                    //value={this.props.MedicalOrders.cups.cupsnom}
                                                    onChange={(e) => {
                                                        //this.props.handlerCUPS(e.target.value);                                               
                                                        this.setState({ loadMedicaments: true }, () => {
                                                            this.props.searchMedicaments(e.target.value).then((dataMedicaments) => {
                                                                this.setState({ dataMedicaments: dataMedicaments, loadMedicaments: false })
                                                            })
                                                        });
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
                                    {!this.state.loadMedicaments ?
                                        <DataReactTable
                                            title=""
                                            reactTableData={reactTableMedicaments}
                                            config={{
                                                withPagination: true,
                                                withSearchEngine: false,
                                                isSortable: false,
                                                watchCustomMenu: false
                                            }}
                                            ReactTableActions={ReactTableActionsMedics}
                                            Callback={(medicament) => {
                                                console.log(medicament);
                                                this.setState({
                                                    medicament: medicament, openMedicaments: false,
                                                    principioactivo: medicament.principioactivo, viaadministracion: medicament.viaadministracion,
                                                    concentracion: medicament.cantidad + medicament.unidadmedida
                                                });
                                            }}
                                        /> : <div style={{ margin: 'auto', width: 280, height: 480 }}>
                                            <div class="load__icon-wrap">
                                                <svg class="load__icon">
                                                    <path fill="#4ce1b6" d="M12,4V2A10,10 0 0,0 2,12H4A8,8 0 0,1 12,4Z" />
                                                </svg>
                                            </div>
                                        </div>}
                                </div>
                            </div>
                        </Modal>
                    </div>
                </div>
            </div>
        )
    }
}

export default reduxForm({
    form: `seccion-form`, // a unique identifier for this form
})(withTranslation('common')(SectionAilment));

SectionAilment.propTypes = {
    ailments: PropTypes.array.isRequired,
    section: PropTypes.string
}